import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tipologicaInterface } from '../interfaces/tipologica.interface';
import { Observable } from 'rxjs';

type tipologicaUrl =
  | 'motivazioni'
  | 'commesse'
  | 'commesseDestinazione'
  | 'statiRichiestaRettifica'
  | 'frequenzeEmail'
  | 'destinatariSollecitoCC'
  | 'unitaPrimoLivello';

@Injectable({
  providedIn: 'root',
})
export class TipologicheService {
  constructor(private readonly http: HttpClient) {}
  baseUrl = 'api/tipologiche/';
  get(endPoint: tipologicaUrl) {
    return this.http.get<tipologicaInterface[]>(this.baseUrl + endPoint);
  }

  getInterventi(codiceCommessa: string) {
    return this.http.get<tipologicaInterface[]>(this.baseUrl + 'interventi/codiceCommessa/' + codiceCommessa);
  }

  getIsCommessaTariffa(codiceCommessa: string) {
    return this.http.get<any>(this.baseUrl + 'commesse/isCommessaATariffa/' + codiceCommessa);
  }

  getRuoliTagetik(rettifica: any) {
    return this.http.post(this.baseUrl + 'ruoliTagetik/richiestaRettifica', rettifica);
  }
  getRuoliTagetikRev(data: any) : Observable<any> {
    return this.http.post(this.baseUrl + 'ruoliTagetik/codiceCommessa', data);
  }
}
